import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from "../../apa/Launcher";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class EpgLineUp extends AbstractRequestTask {
  constructor(parameters) {

    super();
    this.customParameters = parameters;
  }

  getHeaders() {
    return {};
  }

  getParams() {
    const params = super.getParams();
    delete params.user_token;
    return {
      ...params,
      ...this.customParameters,
      ...{
        tenant_code: 'clarovideo',
        metadata: 'full'
      }
      // VALIDAR ESTOS DATOS.
    };
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");

    return `${http}${url}/services/epg/lineup`;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default EpgLineUp;



// WEBPACK FOOTER //
// ./src/requests/tasks/epg/EpgLineUp.js